import React from 'react';

import StarIcon from '@ps-design-system/icons/StarFilled/StarFilled16';

export const CateringExperienceBanner = () => (
  <section className="catering-experience-section ps-container-lg-margin ps-container-fixed">
    <div className="ps-row">
      <div className="col-xs-12 col-lg-6 catering-experience-left">
        <div style={{ marginBottom: '12px' }}>
          {Array.from({ length: 5 }).map((_, i) => (
            <StarIcon key={`catering-star-${i}`} />
          ))}
        </div>

        <h4 className="tw-headline-6 lg:tw-display-1 no-margin">
          A great experience,{' '}
          <span className="tw-headline-6-b lg:tw-display-1-b">
            guaranteed
          </span>
        </h4>
      </div>

      <div className="col-xs-12 col-lg-6">
        <p className="no-margin tw-body-3">
          Our goal is always to deliver excellent quality and ensure you
          feel great about your choice. We're confident you'll be satisfied
          with your purchase.
          <br />
          <br />
          If your order doesn't meet our high standards, we'll make it
          right. Simply take photos to document any issues, and reach out to
          us within 48 hours after your event.
        </p>
      </div>
    </div>
  </section>
);
